export default {
      id: "icon-search-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }